<template>
  <el-dialog :width="width" title="处理" :visible.sync="visible" append-to-body @closed="onClosed">
    <el-form ref="form" :model="data" :rules="rules" label-width="85px" v-loading="isLoading">
      <el-form-item label="节点名称" prop="NodeId" style="margin-bottom: 10px;">
        <select-input
          placeholder="选择节点"
          :label="data.NodeName"
          v-model="data.NodeId"
          @click="openTree"
        />
      </el-form-item>
      <template v-if="data.NodeType!=0">
        <div style="border-top: 1px solid #DCDFE6"></div>
        <div class="row-head">
          <span>人员列表</span>
          <div style="float: right;">
            <el-button type="primary" @click="openEmp">添加</el-button>
          </div>
        </div>
        <el-table :data="Emps" border>
          <el-table-column prop="EmpName" label="人员名称" />
          <el-table-column label="操作" align="center" width="60">
            <template slot-scope="{$index}">
              <el-button @click="delEmp($index)" type="text">删除</el-button>
            </template>
          </el-table-column>
        </el-table>
      </template>
      <div class="row-head">
        <span>意见</span>
      </div>
      <el-input type="textarea" v-model="data.Comment" placeholder="请输入意见"></el-input>
    </el-form>
    <div slot="footer" class="dialog-footer">
      <el-button type="primary" :loading="isLoading" @click="onHandle">确 定</el-button>
      <el-button @click="onClose">关 闭</el-button>
    </div>
    <el-dialog :width="width" title="选择节点" :visible.sync="showTree" append-to-body>
      <div v-loading="treeLoading">
        <el-tree :data="tdata" :props="tprops" default-expand-all :expand-on-click-node="false">
          <span class="custom-tree-node" slot-scope="{data}">
            <!-- 节点 Node （树中申请人、审批人、抄送人、条件分支节点）/流转 Flow （树中条件节点） -->
            <span style="display: inline-block;width: calc(100% - 40px);">
              <span v-if="data.TreeNodeType==0" :style="color(data)">{{ data.Node.NodeName }}</span>
              <span v-else :style="color(data)">{{ data.Flow.FlowName }}</span>
            </span>
            <template v-if="data.TreeNodeType==0">
              <span class="tree-btn" v-if="data.Node.NodeType<2">
                <el-button type="text" @click="onSelect(data.Node)">选择</el-button>
              </span>
            </template>
          </span>
        </el-tree>
      </div>
      <div slot="footer" class="dialog-footer">
        <el-button @click="showTree = false">取 消</el-button>
      </div>
    </el-dialog>
    <teacher-dialog ref="teacherDialog" in-dialog selectable multiple @select-multiple="setEmp" />
  </el-dialog>
</template>
<script>
import teacherDialog from "@/components/wf/process/teacher/listDialog";
export default {
  components: {
    teacherDialog,
  },
  data() {
    return {
      api: require("@/api/wf/instance").default,
      process_api: require("@/api/wf/process").default,
      data: {
        WorkId: 0,
        Comment: "",
        InstanceId: 0,
        NodeId: "",
        NodeName: "",
        NodeType: 0,
        EmpIds: [],
      },
      rules: {
        NodeId: [{ required: true, message: "选择节点" }],
      },
      VersionId: "",
      Emps: [],
      isLoading: false,
      visible: false,
      showTree: false,
      tdata: [],
      tprops: { children: "ChildNodes" },
      treeLoading: false,
    };
  },
  computed: {
    width() {
      return this.$store.state.isMB ? "86%" : "500px";
    },
  },
  methods: {
    openCreate(data) {
      this.VersionId = data.VersionId;
      this.data.WorkId = data.WorkId;
      this.data.Comment = data.Comment;
      this.visible = true;
    },
    color(data) {
      if (data.TreeNodeType == 0) {
        if (data.Node.NodeType == 0) {
          return "color: #4A94FF;";
        }
        if (data.Node.NodeType == 1) {
          return "color: #FCAD22;";
        }
        if (data.Node.NodeType == 2) {
          return "color: #3CB4B2;";
        }
        if (data.Node.NodeType == 3) {
          return "color: #DBDBDB;";
        }
        if (data.Node.NodeType == 98) {
          return "color: #F56C6C;";
        }
      } else {
        console.log("流转");
        return "color: #88939F;";
      }
    },
    openTree() {
      this.showTree = true;
      this.treeLoading = true;
      this.process_api.getTreeVersion(this.VersionId).then((res) => {
        this.treeLoading = false;
        var version = res.Data.Version;
        this.tdata = [version.RootNode];
      });
    },
    onSelect(node) {
      if (this.data.NodeId != node.NodeId) this.Emps = [];
      console.log("select", node);
      this.data.NodeId = node.NodeId;
      this.data.NodeName = node.NodeName;
      this.data.NodeType = node.NodeType;
      // this.$emit("on-select", { ...this.data });
      this.showTree = false;
    },
    openEmp() {
      this.$refs.teacherDialog.open().then((that) => {
        that.getData();
      });
    },
    setEmp(data) {
      console.log("data", data);
      data.forEach((x) => {
        this.Emps.push({
          EmpId: x.TeacherId,
          EmpName: x.TeacherName,
        });
      });
    },
    delEmp(index) {
      this.Emps.splice(index, 1);
    },
    onHandle() {
      this.$refs.form
        .validate()
        .then((valid) => {
          if (!valid) return;
          if (this.data.NodeType != 0 && this.Emps.length == 0) {
            this.$message({
              customClass: "my-msg",
              type: "warning",
              message: "人员不能为空",
            });
            return;
          }
          var data = this.data;
          data.EmpIds = this.Emps.map((x) => x.EmpId);
          this.isLoading = true;
          this.api.handle(data).then((res) => {
            this.isLoading = false;
            if (res.Code == 0) {
              this.$message({
                customClass: "my-msg",
                type: "success",
                message: res.Msg,
              });
              this.$emit("handle-success");
              this.visible = false;
            } else {
              this.$message({
                customClass: "my-msg",
                type: "error",
                message: res.Msg,
              });
            }
          });
        })
        .catch(() => {});
    },
    onClose() {
      if (this.isLoading) {
        this.$message({
          customClass: "my-msg",
          type: "warning",
          message: "任务执行中，请稍候",
        });
      } else {
        this.visible = false;
      }
    },
    onClosed() {
      this.Emps = [];
      this.data.WorkId = 0;
      this.data.Comment = "";
      this.data.InstanceId = 0;
      this.data.NodeId = "";
      this.data.NodeName = "";
      this.data.NodeType = 0;
      this.data.EmpIds = [];
    },
  },
};
</script>
<style lang="scss" scoped>
.tree-btn {
  display: inline-block;
  width: 40px;
  text-align: center;
}
</style>